exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-5dc10949]{width:30%;height:30px}.margin-5px[data-v-5dc10949]{margin-right:5px}.width-20px[data-v-5dc10949]{width:20px}.padding-5px[data-v-5dc10949]{padding-right:3%;padding-left:3%}table>tr>td[data-v-5dc10949]:nth-child(odd){font-weight:600}.table-responsive img[data-v-5dc10949]{width:60px}", ""]);

// exports
